import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { AutoForm, ErrorsField } from "uniforms-semantic";
import {
  ModalComponent,
  ModalActions
} from "/imports/client/components/modals";
import { QueryType } from "/imports/client/components/forms/uniforms/SelectPriceListField";
import { SelectPriceListField } from "/imports/client/components/forms/uniforms";
import { initJSONschema } from "/imports/utils/UI/initJSONschema";
import { CheckBox } from "../../checkbox";

const schema = initJSONschema<{ priceListId: string }>({
  type: "object",
  properties: {
    priceListId: { type: "string" }
  },
  required: ["priceListId"]
});

interface Props {
  show: boolean;
  showModal: (show: boolean) => void;
  onSave: (model: { priceListId: string }) => void;
  query: QueryType;
  loading?: boolean;
}

let formRef;
const Form = ({ onSave, query }: Pick<Props, "onSave" | "query" >) => {
  const defaultFilters = {
    active: true,
    inactive: true
  };
  const [theQuery, setTheQuery] = useState(defaultFilters);
  useEffect(() => {
    setTheQuery({
      ...defaultFilters,
      ...(query || {})
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);
  const { t } = useTranslation();

  return (
    <AutoForm
      schema={schema}
      ref={(ref) => {
        formRef = ref;
      }}
      onSubmit={onSave}
    >
      <CheckBox
        label={t("modal.priceListSelect.checkbox.active")}
        checked={!!theQuery.active}
        onCheckChanged={(val) => {
          setTheQuery({
            ...theQuery,
            active: val
          });
        }}
      />
      <CheckBox
        style={{ marginLeft: 20 }}
        checked={!!theQuery.inactive}
        label={t("modal.priceListSelect.checkbox.nonactive")}
        onCheckChanged={(val) => {
          setTheQuery({
            ...theQuery,
            inactive: val
          });
        }}
      />
      <SelectPriceListField name="priceListId" query={theQuery} />
      <ErrorsField />
    </AutoForm>
  );
};

const SelectPriceListModal = ({
  show,
  showModal,
  onSave,
  query,
  loading
}: Props) => {
  const { t } = useTranslation();
  return (
    <ModalComponent
      show={show}
      showModal={showModal}
      title={t("modal.priceListSelect.title")}
      body={<Form onSave={onSave} query={query} />}
      actions={
        <ModalActions
          {...{
            loading,
            showModal,
            onSave: () => formRef.submit()
          }}
        />
      }
    />
  );
};

export default SelectPriceListModal;
